import classNames from 'classnames';
import { Stack } from '@components/layout';
import './MetadataButtonGroup.scss';

export interface MetadataButtonGroupProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * MetadataButtonGroup component
 * A flex wrapper that sets flex gap and styles the primary buttons to full width.
 * Used in content highlight and lockup metadata groups.
 * @param children - Usually 1-2 Button and 0-2 FloatingButton.
 * @param className - Optional classnames to be included as customization.
 */
export const MetadataButtonGroup: React.FC<MetadataButtonGroupProps> = ({
  children,
  className,
  ...rest
}) => (
  <Stack
    className={classNames('vds-metadata-button-group', className)}
    gap="spacing-medium-small"
    {...rest}>
    {children}
  </Stack>
);
